import React from 'react';
import { Button } from '../Button';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary capturou:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{
            minHeight: '100vh',
            padding: '24px',
            textAlign: 'center',
          }}
        >
          <h2 className="fw-bold text-orange mb-3">Algo deu errado</h2>
          <p className="text-muted mb-4" style={{ maxWidth: 480 }}>
            Ocorreu um erro inesperado. Recarregar a pagina geralmente resolve.
            Se o problema persistir, entre em contato com a Forluz.
          </p>
          <div style={{ width: 240 }}>
            <Button onClick={this.handleReload}>Recarregar</Button>
          </div>
        </div>
      );
    }

    return children;
  }
}
